var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1449.78 491.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_grad",
    gradientUnits: "userSpaceOnUse",
    x1: 766.95,
    y1: 279.41,
    x2: 769.63,
    y2: -53.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35B88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#31B2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CABD6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#logo_grad)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.32 236.39c0-3.35 17.31 4.3 26.27 2.85 37.23-6.03 80.83-118.69 33.32-103.22l-72.22 23.51c-.62.2-1.99-.8-3.64-2.61 19.95-.58 17.88-27.73 13.24-32.22-2.15-2.08-5.4-3.64-10.09-4.41 1.48-.24 3.1-.41 4.87-.49 23.08-1.01 61.13-7.66 109.59-46.12 1.44-1.15 3.46-.73 5.03-.84 1.56-.11 3.24-.17 5.03-.17 6.03 0 10.84 1.45 14.41 4.36 3.57 2.91 5.36 6.81 5.36 11.73 0 168.82-131.17 245.76-131.17 147.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.01 19.03c2.35-7.46 6.2-12.81 11.55-16.04 5.35-3.23 11.22-3.85 17.62-1.83 7.25 2.28 12.61 7.95 16.08 17 3.47 9.06 3.7 18.38 0.69 27.97-2.08 6.61-5.69 11.38-10.83 14.33-5.14 2.95-10.7 3.48-16.67 1.61-7.89-2.48-13.65-7.98-17.29-16.51-3.64-8.52-4.02-17.37-1.14-26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.61 43.11c-1.77 7.62-5.2 13.24-10.28 16.88-5.09 3.64-10.89 4.7-17.42 3.18-7.4-1.72-13.18-6.96-17.34-15.72-4.16-8.76-5.1-18.04-2.83-27.83 1.57-6.75 4.8-11.79 9.7-15.12 4.9-3.33 10.4-4.29 16.49-2.88 8.05 1.87 14.22 6.91 18.5 15.13 4.28 8.22 5.34 17.01 3.17 26.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.67 148.36c1.05-10.83 7.2-16.72 20.65-12.34l58.57 19.07c31.54 10.27 29.6-25.19 24.23-30.38-2.83-2.73-7.57-4.58-14.95-4.9-23.08-1.01-61.12-7.66-109.59-46.12-5.01-3.97-14.08-.21-18.46 3.35-3.57 2.9-5.36 6.81-5.36 11.73 0 64.05 2.05 125.68 2.05 193.58l40.85 0 0-.27c.08.09.15.18.23.27 1.19-40.93-1.86-96.45 1.79-133.99z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: -5.62,
    y: 488.16,
    fill: "currentColor",
    fontFamily: "sans-serif",
    fontWeight: 900,
    fontSize: 193.71
  }, "GO JobMatch")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.19c649529a66b6855a0f14717004407d.svg";
export { ForwardRef as ReactComponent };